import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import _get from 'lodash/get';
import { useDevice } from '@atc/react-device';
import { ContentPreview, Image, SubHeading } from 'reaxl';
import { useBrand } from '@atc/brand';
import homeServicesConfig from '../homeServicesConfig';

/**
 *  Dealer home services content on Content Preview
 *
 */
const HomeServicesItemCard = /*#__PURE__*/memo(_ref => {
  let {
    className,
    imageWidth,
    services,
    orientation = 'landscape',
    customServiceContent = {},
    ...rest
  } = _ref;
  const {
    brand
  } = useBrand();
  const device = useDevice();
  const isXs = _get(device, 'is.xs', true);
  const isFlexWrap = className?.includes('flex-wrap');
  const isDisplayFlex = className?.includes('display-flex');
  const isServicesArray = Array.isArray(services);
  const servicesKeys = isServicesArray ? services : Object.keys(services);
  if (!servicesKeys.length) {
    return null;
  }
  const serviceContent = servicesKeys.map((service, index) => {
    // homeServices stores static content in axl-config
    const homeService = {
      ...homeServicesConfig[service],
      ...customServiceContent[service]
    };
    const imgSrc = brand ? homeService[`iconSrc${brand}`] || '' : homeService.iconSrcatc;
    const icon = imgSrc && /*#__PURE__*/_jsx(Image, {
      className: "margin-bottom-3",
      src: imgSrc,
      alt: "",
      width: 70,
      height: 70
    });
    const body = /*#__PURE__*/_jsx("div", {
      className: "margin-vertical-2"
    }, void 0, homeService.content, !isServicesArray && services[service]);
    const serviceClassNames = clsx({
      // avoid adding margin-bottom to the last row
      'margin-bottom-5': isXs && index < servicesKeys.length - 1 || !isXs && isFlexWrap && index < 3,
      // services on modal (HomeServicesBanner) need smaller margin-right
      'margin-right-sm-5 margin-right-lg-7': isFlexWrap,
      // margin to separate services without flex-wrap
      'display-flex flex-column margin-right-sm-1 margin-right-md-2': isDisplayFlex && !isFlexWrap && index < 2,
      'col-xs-12 padding-left-0': true,
      'col-sm-6 padding-right-5': servicesKeys.length > 1,
      // avoid adding margin-bottom to the second/last row on default UI
      'margin-bottom-sm-5': !isFlexWrap && !isDisplayFlex && servicesKeys.length > 1 && index < 2,
      'col-sm-8': servicesKeys.length === 1
    });
    return /*#__PURE__*/_jsx("div", {
      className: serviceClassNames
    }, `service-${index}`, /*#__PURE__*/_jsx(ContentPreview, {
      contentClassName: "w-100",
      image: icon,
      headline: /*#__PURE__*/_jsx(SubHeading, {
        level: 2
      }, void 0, homeService.title),
      summary: body,
      orientation: orientation,
      mediaPosition: "right"
    }));
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: clsx(className, 'clearfix'),
    "data-cmp": "homeServicesItemCard"
  }, rest), serviceContent);
});
export default HomeServicesItemCard;